import BlockType from '../enums/blockType';
import { Block } from '../types/shared/blocksV3';

function getBlockChildren(blocks: Block[], block: Block): Block[] {
	const deckboxes = blocks.filter((blk) => blk.type === BlockType.DECKBOX);
	const landings = deckboxes.flatMap((dk) => dk.landings || []);
	const stairs = deckboxes.flatMap((dk) => dk.stairs || []);
	const bumpouts = deckboxes.flatMap((dk) => dk.bumpouts || []);

	const allBlocks = [...deckboxes, ...landings, ...stairs, ...bumpouts].filter(
		Boolean
	);

	// Recursively get all descendants
	const getAllDescendants = (parentBlock: Block): Block[] => {
		const children = allBlocks.filter(
			(blk) => blk?.parentBlock?.id === parentBlock.id
		);

		const descendants: Block[] = [];
		for (const child of children) {
			descendants.push(child);
			descendants.push(...getAllDescendants(child));
		}

		return descendants;
	};

	return getAllDescendants(block);
}

export default getBlockChildren;
